module.exports = __webpack_public_path__ + "img/pic-paging-service-2-2.4adffc20.jpg";